import { faCheckCircle, faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import SubTabNoData from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabNoData";
import SubTabParent from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent";
import SubTabTable from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabTable";
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import SubTabSection from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabSection";
import FormSelect from "../../../../_shoru_shared_library/components/form/FormSelect";

function ProjectStatsTab(props) {

  const allProjectData = props.projectData;
  const allCastingData = props.extraData;
  const [body, setBody] = useState(_parseToTable(allProjectData, allCastingData));
  const [seasons, setSeasons] = useState(props.organisationData.seasons.filter((x) => x.active));
  const [season, setSeason] = useState((seasons && seasons.length > 0) ? seasons[0].uid : '-undefined');

  useEffect(() => {
    if(!season) return;
    if(season === '-undefined') {
      setBody(_parseToTable(allProjectData, allCastingData))
    }
    else {  
      const filterProject = (x) => {return x.season === season}
      const filteredProjects = allProjectData.filter(filterProject);
      const filteredProjectIds = filteredProjects.map((p) => { return p.uid });
      const filterCasting = (x) => {return filteredProjectIds.includes(x.uid)}
      const filteredCasting = allCastingData.filter(filterCasting);
      setBody(_parseToTable(filteredProjects, filteredCasting));
    }
  }, [season])

  const header = ['Project Name', 'Booking Open?', 'Bookable Slots', 'Bookings', '% Booked', 'Extra Slots', 'Roles', 'Person(s) / Role']

  if(body.length > 0) 
  {
    return (
      <SubTabParent passData={props}>
        <SubTabSection>
          <FormSelect title='Filter' value={season} setValue={setSeason} >
            <option value='-undefined'>[All Projects]</option>
            {
              seasons.map((s) => {
                return <option value={s.uid}>{s.name}</option>
              })
            }
          </FormSelect>
        </SubTabSection>
        <SubTabTable header={header} body={body} numbered />
      </SubTabParent>
    ) 
  }
  else 
  {
    return (
      <SubTabNoData 
        icon={faPlusSquare} 
        title='No Projects' 
        description='Create projects to see them here' 
      />
    )
  }

}

export default ProjectStatsTab;



const _parseToTable = (allProjectData, allCastingData) => {

  console.log("Parsing to table with:\n", allProjectData, "\n", allCastingData)
  let roleArray = allCastingData.map((project) => {

    var name = null;
    allProjectData.forEach((p) => {
      if (p.uid === project.uid) name = p.name;
    })

    const bookableSlots = project.slots.filter((x) => {return x.time_id !== null})
    const extraSlots = project.slots.filter((x) => {return x.time_id === null}).length

    var bookings = 0;
    bookableSlots.forEach((slot) => {if (slot.auditionee_id !== null) bookings++;})

    const personsPerRole = Math.round((10 * (bookings + extraSlots) / project.roles.length)) / 10;

    return [...[
      name,
      (project.booking_enabled? <FontAwesomeIcon style={{color: '#2ecc71'}} icon={faCheckCircle}/> : <FontAwesomeIcon style={{color: '#e74c3c'}} icon={faCircleXmark} />),
      bookableSlots.length,
      bookings,
      bookableSlots.length === 0? null : (Math.round((bookings / bookableSlots.length) * 100)) + '%',
      extraSlots === 0? null : extraSlots,
      project.roles.length === 0? null : project.roles.length,
      project.roles.length === 0? null : <div style={{color: getPersonsPerRoleColour(personsPerRole)}}>{personsPerRole}</div>
    ]];
  })
  return roleArray;
}


const getPersonsPerRoleColour = (personsPerRole) => {

  if        (personsPerRole < 1)  return '#e74c3c';
  else if   (personsPerRole < 2)  return '#e67e22';
  else if   (personsPerRole < 3)  return '#f1c40f';
  else if   (personsPerRole < 5)  return '#2ecc71';
  else                            return '#9b59b6';

}